/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_Title_ColorInputs */

const en_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exclusive Trees`)
};

const ar_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار حصرية من بلس`)
};

const de_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exklusive Bäume`)
};

const es_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`árboles exclusivos Plus`)
};

const fr_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres exclusifs Plus`)
};

const it_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi esclusivi Plus`)
};

const ja_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の木`)
};

const ko_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 전용 나무`)
};

const pt_br_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores exclusivas Plus`)
};

const ru_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивные деревья Plus`)
};

const th_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้สุดพิเศษสำหรับ Plus`)
};

const tr_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Özel Ağaçlar`)
};

const zh_cn_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 梦幻限定树`)
};

const zh_tw_daily_paywall_tree_title_color = /** @type {(inputs: Daily_Paywall_Tree_Title_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 夢幻限定樹`)
};

/**
* | output |
* | --- |
* | "Plus Exclusive Trees" |
*
* @param {Daily_Paywall_Tree_Title_ColorInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_title_color = /** @type {((inputs?: Daily_Paywall_Tree_Title_ColorInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_Title_ColorInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_title_color(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_title_color(inputs)
	if (locale === "de") return de_daily_paywall_tree_title_color(inputs)
	if (locale === "es") return es_daily_paywall_tree_title_color(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_title_color(inputs)
	if (locale === "it") return it_daily_paywall_tree_title_color(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_title_color(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_title_color(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_title_color(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_title_color(inputs)
	if (locale === "th") return th_daily_paywall_tree_title_color(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_title_color(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_title_color(inputs)
	return zh_tw_daily_paywall_tree_title_color(inputs)
});